module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA1AQAAAAD+U1HpAAAAAnRSTlMAAHaTzTgAAAAOSURBVHgBY6AcjIJRAAACRwABpK3iRgAAAABJRU5ErkJggg=="